import {
  mapCompanyContactType,
  mapVenueOverviewVersionType,
  PermissionNameUnionType,
  useFindAllVenueMerchContactsSuspense,
  useFindVenueOverviewVersionSuspense,
} from '@api';
import {
  EditActionIcon,
  TouringCard,
  TouringCardActions,
  TouringCardHeader,
  TouringCardSection,
  TouringCardTitle,
} from '@common';
import { usePermissionContext } from '@hypeit-gmbh/hypeit-ui-core';
import { Modal } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';
import { Route } from 'src/routes/_rootLayout/venues/$id.overview.$version';
import { VenueMerchForm, VenueMerchTable } from './components';

export const VenueMerch: React.FC = () => {
  const { t } = useTranslation('venueDetailsOverview');
  const [opened, { open: openModal, close: closeModal }] = useDisclosure(false);
  const { id, version } = Route.useParams();

  const { data: overviewVersion } = useFindVenueOverviewVersionSuspense(
    id,
    version,
    {
      query: {
        select: (data) => mapVenueOverviewVersionType(data.data),
      },
    }
  );
  const { data: contacts } = useFindAllVenueMerchContactsSuspense(id, {
    query: {
      select: (data) => data.data.map(mapCompanyContactType),
    },
  });
  const { hasPermission } = usePermissionContext<PermissionNameUnionType>();

  const userCanEditVenueMerch = hasPermission({
    permission: 'VENUES_OVERVIEW',
    action: 'WRITE',
  });

  return (
    <>
      <TouringCard data-testid="venue-merch">
        <TouringCardHeader>
          <TouringCardTitle>{t('VENUE_MERCH.TITLE')}</TouringCardTitle>
          <TouringCardActions>
            {userCanEditVenueMerch && <EditActionIcon onClick={openModal} />}
          </TouringCardActions>
        </TouringCardHeader>
        <TouringCardSection>
          <VenueMerchTable venueMerch={overviewVersion.merch} />
        </TouringCardSection>
      </TouringCard>
      <Modal
        opened={opened}
        onClose={closeModal}
        title={t('VENUE_MERCH.EDIT_MODAL_TITLE')}
      >
        <VenueMerchForm
          venueId={id}
          overviewVersion={version}
          venueMerch={overviewVersion.merch}
          onClose={closeModal}
          contacts={contacts}
        />
      </Modal>
    </>
  );
};
